import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const items = [{
  title: "La Guía Maestra 'Cena en 15'",
  desc: 'El manual paso a paso para dominar el sistema de ensamble.'
}, {
  title: 'Auditoría de Despensa USA',
  desc: "La lista exacta de los 10 'salvavidas' que debes comprar en Walmart o Aldi."
}, {
  title: 'El Recetario de Emergencia',
  desc: "21 combinaciones de cenas reales (7 con pollo rostizado, 7 de sartén rápido y 7 de 'cero fuego')."
}, {
  title: "Guía de 'Hacks' de Limpieza",
  desc: 'Cómo cocinar sin ensuciar más de un plato.'
}, {
  title: 'Calendario de Cenas de Lunes a Viernes',
  desc: "Para que nunca más tengas que pensar '¿qué hay de cenar?'."
}];
export function WhatYouGet() {
  return <section className="py-24 px-4 bg-brand-bg-alt" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-196">
          <h2 className="text-4xl md:text-5xl mb-6 text-brand-dark" data-id="element-197">
            Todo Lo Que Recibes Hoy
          </h2>
        </motion.div>

        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl shadow-stone-200/50 border border-stone-100" data-id="element-198">
          <div className="space-y-6" data-id="element-199">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-4 hover:bg-stone-50 rounded-2xl transition-colors" data-id="element-200">
                <div className="flex-shrink-0 mt-1" data-id="element-201">
                  <CheckCircle2Icon className="w-8 h-8 text-brand-green" data-id="element-202" />
                </div>
                <div data-id="element-203">
                  <h3 className="text-xl font-bold text-brand-dark mb-1 font-sans" data-id="element-204">
                    {item.title}
                  </h3>
                  <p className="text-stone-600 leading-relaxed" data-id="element-205">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="mt-10 text-center" data-id="element-206">
            <a href="#pricing" className="inline-block w-full sm:w-auto bg-brand-accent hover:bg-brand-accent-hover text-white font-bold text-lg py-4 px-10 rounded-xl shadow-lg shadow-brand-accent/30 transition-colors" data-id="element-207">
              OBTENER ACCESO INMEDIATO
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}